import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import pt from './locales/pt.json';
import en from './locales/en.json';
import es from './locales/es.json';

const resources = {
  pt: { translation: pt },
  en: { translation: en },
  es: { translation: es }
};

const initI18n = async () => {
  await i18n
    .use(initReactI18next)
    .init({
      resources,
      lng: 'pt',
      fallbackLng: 'pt',
      interpolation: {
        escapeValue: false
      },
      react: {
        useSuspense: true
      }
    });
};

// Initialize i18n immediately
initI18n().catch(console.error);

export default i18n;